import React, { useState } from 'react';
import NavigationList from '../components/NavigationList';
import { useNavigate, useParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import ReportsList from '../components/ReportsList';
import SqlsList from '../components/SqlsList';
import ComponentsList from '../components/ComponentsList';
import FiltersList from '../components/FiltersList';
import TemplateReportsList from '../components/TemplateReportsList';
import ArrayStore from 'devextreme/data/array_store';
import TabPanel, { Item } from 'devextreme-react/tab-panel';
import LayoutsList from '../components/LayoutsList';


const navigationArray0 = [
    { id: 1, text: 'SQL-запросы', icon: 'sqls', action: 'sqls', visible: true },
    { id: 2, text: 'Компоненты отчетов', icon: 'components', action: 'components', visible: true },
    { id: 3, text: 'Фильтры отчетов', icon: 'filters', action: 'filters', visible: true },
    { id: 4, text: 'Шаблоны отчетов', icon: 'templatereports', action: 'templatereports', visible: true }
];

const navigationArray = navigationArray0.filter(item => item.visible);

const navigationArrayDataSource = new ArrayStore({
    key: 'id',
    data: navigationArray,
});

const findNavigationArray = (action: String, defaultAction: String) => {
    const defIndex = 0;
    action = action || "";
    defaultAction = defaultAction || navigationArray[defIndex].action;
    let res = navigationArray.find(item => item.action.toLowerCase() == action.toLowerCase());
    if (!res)
        res = navigationArray.find(item => item.action.toLowerCase() == defaultAction.toLowerCase());
    if (!res)
        res = navigationArray[defIndex];
    return res;
}

const SetupPage = () => {
    const navigate = useNavigate();
    const params = useParams();
    const [currNavigation, setCurrNavigation] = useState(navigationArray[0]);
    const newNavigation = findNavigationArray(params.pagename, currNavigation?.action);
    if (newNavigation.action != currNavigation.action) {
        setCurrNavigation(newNavigation);
    }
    let reportId = new URLSearchParams((location.search ? location.search : "").toLowerCase()).get("id");

    //    const [currNavigation, setCurrNavigation] = useState(findNavigationArray(params.pagename));

    const navigationItemClick = (item) => {
        navigate(`/setup/${item.itemData.action}`, { replace: true });
        return;
    }

    return (<>
        <div className="left-content" hidden>
            <br />
            <NavigationList
                dataSource={navigationArrayDataSource}
                onItemClick={navigationItemClick}
                selectedItemKeys={[currNavigation.id]}
            />
        </div>
        <div className="center-content">
            <div
                style={{ height: "100%" }}
            >
                <TabPanel                    
                    elementAttr={{ class: "setup-tabpanel" }}
                    height="100%"
                    width="100%"
                    deferRendering={false}
                    repaintChangesOnly={true}
                //            onInitialized={onTabPanelInitialized}
                >
                    <Item
                        title="SQL-запросы"
                        component={SqlsList}
                    />
                    <Item
                        title="Компоненты отчетов"
                        component={ComponentsList}
                    />
                    <Item
                        title="Фильтры отчетов"
                        component={FiltersList}
                    />
                    <Item
                        title="Макеты отчетов"
                        component={LayoutsList}
                    />                    
                    <Item
                        title="Шаблоны отчетов"
                        component={TemplateReportsList}
                    />
                </TabPanel>
            </div>
            <div className="sub-title__">
            </div>
        </div>

        <div className="center-content" hidden>
            {false && <p
            >{currNavigation.text}</p>
            }
            <div
                style={{ height: "100%" }}
            >
                {(currNavigation.action == "reports" && !reportId) &&
                    <ReportsList />
                }
                {(currNavigation.action == "sqls") &&
                    <SqlsList
                    />
                }
                {(currNavigation.action == "components") &&
                    <ComponentsList
                    />
                }
                {(currNavigation.action == "filters") &&
                    <FiltersList
                    />
                }
                {(currNavigation.action == "templatereports") &&
                    <TemplateReportsList
                    />
                }
                

            </div>
            <div className="sub-title__">
            </div>
        </div>
        <div className="right-content">
            Правая сторона
        </div>
    </>
    );
}
export default observer(SetupPage);